import { render, staticRenderFns } from "./filter_head.vue?vue&type=template&id=25d5da37&scoped=true&"
import script from "./filter_head.vue?vue&type=script&lang=js&"
export * from "./filter_head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d5da37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d5da37')) {
      api.createRecord('25d5da37', component.options)
    } else {
      api.reload('25d5da37', component.options)
    }
    module.hot.accept("./filter_head.vue?vue&type=template&id=25d5da37&scoped=true&", function () {
      api.rerender('25d5da37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/filter_view/filter_head.vue"
export default component.exports